import { Controller } from "@hotwired/stimulus"
import CardFan from "../src/card_fan"

// ห้องแม่หมอ — คุมลำดับแชท: ถาม → เปิดพัดไพ่ → จับครบ → server สุ่มจริง → พลิก → ต่อ bubble คำตอบ
// ถามอะไรก็ได้ ไม่มีเรื่องหมวดฝั่งจอแล้ว — AI router ฝั่ง server ตัดสินเองว่าจับ 2 หรือ 3 ใบ
// ไพ่บนจอเป็นละครเหมือน card_pick — ค่าจริงมาจาก server ตอน POST draw เท่านั้น
export default class extends Controller {
  static targets = ["thread", "chips", "input", "send", "fanTemplate", "rating",
                    "credits", "creditsCount", "topup", "topupText", "resetRow",
                    "zoom", "zoomArt", "zoomName"]
  static values = {
    askUrl: String,
    confirmUrl: String, // กดยืนยันปิดแชทเก่าก่อนขึ้นแชทใหม่
    drawUrl: String,
    rateUrl: String,
    rereadUrl: String,
    streamUrl: String,
    topupUrl: String,
    chips: Object, // { questions: [] }
    pendingPick: Number, // refresh กลางทางระหว่างรอจับไพ่ — เปิดพัดค้างไว้ให้จับต่อ (0 = ไม่มี)
    names: Object,
    colors: Object,
    arts: Object,
    texts: Object // ถ้อยคำบนจอตามภาษาของหน้า (oracle.js ใน yml) — ห้าม hardcode ภาษาในไฟล์นี้
  }

  connect() {
    this.busy = false
    this.renderChips()
    if (this.pendingPickValue > 0) this.openFan(this.pendingPickValue)
    this.scrollToEnd(false)
  }

  // ---- ถาม (ชิปหรือพิมพ์เอง) ----

  submit(event) {
    event.preventDefault()
    const question = this.inputTarget.value.trim()
    if (question) this.ask(question)
  }

  // category = หมวดที่รู้แน่นอนจากเมนูความรักสองชั้น (undefined = ให้ server ตัดสินเองตามเดิม)
  async ask(question, category) {
    if (this.busy) return
    this.busy = true
    this.threadTarget.querySelector(".oracle-close-confirm")?.remove() // ถามใหม่ = คำเตือนใบเก่าตกรุ่น
    this.loveBubble?.remove() // ถามแล้ว = เมนูเลือกสถานะจบหน้าที่ ไม่ต้องค้างในสายแชท
    this.loveBubble = null
    this.appendBubble("is-user", question)
    this.inputTarget.value = ""
    this.chipsTarget.innerHTML = "" // ระหว่างวงจับไพ่ ชิปหลบไปก่อน
    try {
      const data = await this.post(this.askUrlValue, category ? { question, category } : { question })
      // ถามความรักลอย ๆ — แม่หมอถามสถานะกลับก่อน ยังไม่หักเครดิต กดสถานะแล้วถามคำถามเดิมซ้ำพร้อมหมวด
      if (data.ask_status) {
        this.askLoveStatus(data)
        return
      }
      // ขึ้นแชทใหม่ (คุยครบ 5 คำถาม หรือสลับเรื่อง) — ต้องกดยืนยันก่อน ยังไม่ปิดแชทเก่าให้
      // คำทำนายในหน้านี้กลับมาอ่านไม่ได้อีก ต้องเหลือจังหวะให้แคปหน้าจอเก็บไว้ (Lek สั่ง 3 ส.ค. 69)
      if (data.new_chat) {
        this.askCloseConfirm(question, data)
        return
      }
      this.appendBubble("is-oracle", data.invite)
      this.appendCost(data.cost_hint) // ป้ายราคาใต้คำชวน — เห็นก่อนกรีดไพ่
      this.openFan(data.pick)
    } catch (error) {
      this.appendBubble("is-oracle", error.userMessage || this.textsValue.system_error)
      // เครดิตหมด (402) — เด้งชวนเติมตั้งแต่ยังไม่โชว์ไพ่ให้กรีด
      if (error.status === 402) this.openTopup(error.userMessage)
      this.renderChips()
    } finally {
      this.busy = false
    }
  }

  // ---- ยืนยันก่อนปิดแชทเก่า (Lek สั่ง 3 ส.ค. 69) ----
  // ปิดแชทแล้วคำทำนายหน้านั้นกลับมาอ่านไม่ได้อีก — บอกตรง ๆ แล้วรอให้กดเอง
  // การ์ดยืนยันวางต่อท้ายสายแชท ไม่ใช่โมดัลคลุมจอ เพราะต้องแคปหน้าจอคำทำนายได้ตอนที่การ์ดโผล่อยู่

  askCloseConfirm(question, data) {
    const card = document.createElement("div")
    card.className = "oracle-close-confirm"

    const text = document.createElement("p")
    text.className = "oracle-close-text"
    text.textContent = data.close_notice
    card.appendChild(text)

    const buttons = document.createElement("div")
    buttons.className = "oracle-close-buttons"
    const confirm = document.createElement("button")
    confirm.type = "button"
    confirm.className = "oracle-close-go"
    confirm.textContent = data.confirm_label
    confirm.addEventListener("click", () => this.confirmNewChat(card, question, data))
    const keep = document.createElement("button")
    keep.type = "button"
    keep.className = "oracle-close-keep"
    keep.textContent = data.keep_label
    keep.addEventListener("click", () => this.keepReading(card, question))
    buttons.append(confirm, keep)
    card.appendChild(buttons)

    this.threadTarget.appendChild(card)
    this.scrollToEnd()
  }

  // กดยืนยัน — ปลดล็อกฝั่ง server ก่อน แล้วค่อยล้างจอเปิดวงใหม่
  async confirmNewChat(card, question, data) {
    if (this.busy) return
    this.busy = true
    try {
      await this.post(this.confirmUrlValue, {})
      card.remove()
      this.startNewChat(question)
      this.appendBubble("is-oracle", data.invite)
      this.appendCost(data.cost_hint)
      this.openFan(data.pick)
    } catch (error) {
      this.appendBubble("is-oracle", error.userMessage || this.textsValue.system_error)
    } finally {
      this.busy = false
    }
  }

  // ขอแคปหน้าจอก่อน — คำถามกลับไปรออยู่ในช่องพิมพ์ กดส่งใหม่เมื่อไหร่ก็ได้
  // ฝั่ง server ไม่ต้องสั่งอะไร: คำถามที่ยังไม่ยืนยันเดินต่อไม่ได้อยู่แล้ว และถูกทิ้งตอนถามครั้งถัดไป
  keepReading(card, question) {
    card.remove()
    const asked = [...this.threadTarget.querySelectorAll(".oracle-bubble.is-user")].pop()
    if (asked && asked.textContent === question) asked.remove()
    this.inputTarget.value = question
    this.renderChips()
    this.scrollToEnd()
  }

  // ล้างจอเริ่มแชทใหม่ — บทเก่ายังอยู่ใน DB (ไม่คืนเครดิต) แค่ไม่เกะกะแชทวงใหม่
  // คำถามที่เพิ่งพิมพ์วางกลับเป็น bubble แรกของแชทใหม่ ไม่ให้หายไปกับบทเก่า
  startNewChat(question) {
    const intro = this.threadTarget.querySelector(".oracle-intro") // หัวแชทอยู่ต่อ เหมือนตอนรีเฟรช
    const resetRow = this.hasResetRowTarget ? this.resetRowTarget : null // ปุ่มเริ่มใหม่ก็ต้องรอด
    this.threadTarget.innerHTML = ""
    if (intro) this.threadTarget.appendChild(intro)
    if (resetRow) this.threadTarget.appendChild(resetRow)
    const divider = document.createElement("div")
    divider.className = "oracle-divider"
    divider.textContent = this.textsValue.new_chat_divider
    this.threadTarget.appendChild(divider)
    this.appendBubble("is-user", question)
  }

  // ---- พัดไพ่ ----

  openFan(count) {
    this.fanCount = count
    this.fanPicked = [] // [{ card: ใบในพัด, slot: ช่องที่ลงไป }] เรียงตามลำดับที่เลือก
    this.fanLocked = false

    const fan = this.fanTemplateTarget.content.firstElementChild.cloneNode(true)
    // คำถามต่อเนื่องจับแค่ 2 ใบ — ตัดช่องที่เกินทิ้ง ไม่ใช่ซ่อนไว้เฉย ๆ (slotTargets จะได้ตรงกับจำนวนจริง)
    this.fanSlots = [...fan.querySelectorAll("[data-fan-slot]")]
    this.fanSlots.splice(count).forEach((slot) => slot.remove())
    this.fanSlots.forEach((slot) => slot.addEventListener("click", () => this.unpickCard(slot)))

    this.fanRoot = fan
    this.threadTarget.appendChild(fan) // ต้องอยู่ใน DOM ก่อน CardFan ถึงวัดความกว้างได้
    this.fan = new CardFan(fan.querySelector(".card-fan"), { onPick: (card) => this.pickCard(card) })
    this.syncFan()
    this.scrollToEnd()
  }

  // เลือกครบแล้วเปิดไพ่เลย ไม่มีปุ่มยืนยัน (Lek สั่ง 2 ส.ค. 69) —
  // ถอนคืนได้เฉพาะก่อนใบสุดท้าย ซึ่งเป็นจังหวะเดียวที่คนอยากเปลี่ยนใจอยู่แล้ว
  pickCard(card) {
    if (this.fanLocked || this.fanPicked.length >= this.fanCount) return

    this.fanPicked.push({ card, slot: this.fanSlots[this.fanPicked.length] })
    this.fan.take(card)
    this.syncFan()

    if (this.fanPicked.length >= this.fanCount) this.confirmFan()
  }

  // แตะช่องที่มีไพ่อยู่ = คืนใบนั้นกลับพัด แล้วรูดใบที่เหลือมาชิดช่องซ้าย
  unpickCard(slot) {
    if (this.fanLocked) return

    const at = this.fanPicked.findIndex((entry) => entry.slot === slot)
    if (at < 0) return

    this.fan.release(this.fanPicked[at].card)
    this.fanPicked.splice(at, 1)
    this.fanPicked = this.fanPicked.map((entry, i) => ({ card: entry.card, slot: this.fanSlots[i] }))
    this.syncFan()
  }

  syncFan(text) {
    this.fanSlots.forEach((slot, i) => slot.classList.toggle("is-filled", i < this.fanPicked.length))
    this.fanRoot.querySelector("[data-fan-status]").textContent =
      text || this.t("pick_progress", { picked: this.fanPicked.length, total: this.fanCount })
  }

  confirmFan() {
    if (this.fanLocked || this.fanPicked.length < this.fanCount) return

    this.fanLocked = true
    this.fan.lock()
    this.syncFan(this.textsValue.opening)
    this.draw(this.fanRoot)
  }

  async draw(fan) {
    const typing = this.appendTyping()
    try {
      const data = await this.post(this.drawUrlValue, {})
      this.updateCredits(data.credits)
      // เปิดท่อ stream ตั้งแต่ตอนพลิกไพ่เลย — ข้อความที่มาก่อนพลิกจบพักไว้ใน state
      // (ตัดช่วง "..." เปล่า ๆ ลง ~2 วิ — Lek ทัก 2 ส.ค. 69 ว่ารอจุดเต้นนานไป)
      const state = { pending: "", target: null, bubble: null, typing, stream: data.stream, done: null, failed: false }
      const streaming = this.streamAnswer(state)
      await this.reveal(data.cards, data.arts)
      // เก็บพัดไพ่ (ไพ่ที่หงายอยู่ใน bubble คำตอบแล้ว) — ตัดทั้งก้อนไม่ให้ thread รก
      this.fan?.destroy()
      setTimeout(() => fan.remove(), 600)
      // เปลือก bubble (ไพ่+ช่องว่าง) มาก่อน แล้วเทข้อความที่พักไว้ + ที่ไหลต่อเข้าไป
      const bubble = this.appendBubble("is-oracle", null, data.shell)
      this.attachStream(state, bubble)
      await streaming
    } catch (error) {
      typing.remove()
      // เครดิตหมดคาที่ (เปิดสองแท็บถามพร้อมกัน) — คำถามถูกยกเลิกฝั่ง server แล้ว ไม่ต้องให้เลือกไพ่ต่อ
      if (error.status === 402) {
        this.fan?.destroy()
        fan.remove()
        this.appendBubble("is-oracle", error.userMessage)
        this.openTopup(error.userMessage)
        this.renderChips()
        return
      }
      // ยิงไม่ผ่าน — ปลดล็อก แล้วคืนใบสุดท้ายกลับพัด (ไม่มีปุ่มยืนยันแล้ว การแตะใบสุดท้ายซ้ำ
      // คือทางเดียวที่จะยิงใหม่ได้ ถ้าไม่คืนให้ ช่องจะเต็มค้างแล้วแตะอะไรก็ไม่เกิดอะไรขึ้น)
      this.fanLocked = false
      this.fan.lock(false)
      const last = this.fanPicked.pop()
      if (last) this.fan.release(last.card)
      this.syncFan(this.textsValue.draw_failed)
    }
  }

  // ผูก bubble เข้ากับท่อที่ไหลอยู่ — เทข้อความที่พักไว้ก่อน แล้วเดินต่อสด ๆ
  attachStream(state, bubble) {
    state.bubble = bubble
    state.target = bubble.querySelector("[data-stream-answer]")
    if (state.pending) {
      state.typing.remove()
      state.target.textContent = state.pending
      state.pending = ""
      this.scrollToEnd(false)
    }
    if (state.failed) {
      state.typing.remove()
      this.showStreamFailure(state.stream, state.target)
    } else if (state.done) {
      state.typing.remove()
      this.finishStream(state.done, state.stream, bubble, state.target)
    }
  }

  // ---- อ่านคำตอบจากท่อ SSE — ตัวหนังสือไหลเข้า bubble ทีละชิ้น ----

  async streamAnswer(state) {
    try {
      const response = await fetch(this.streamUrlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
        },
        body: JSON.stringify(state.stream)
      })
      if (!response.ok || !response.body) throw new Error(`stream failed: ${response.status}`)

      const reader = response.body.getReader()
      const decoder = new TextDecoder()
      let buffer = ""
      while (true) {
        const { done, value } = await reader.read()
        if (done) break
        buffer += decoder.decode(value, { stream: true })
        let cut
        while ((cut = buffer.indexOf("\n\n")) >= 0) {
          const frame = buffer.slice(0, cut)
          buffer = buffer.slice(cut + 2)
          const line = frame.split("\n").find((l) => l.startsWith("data: "))
          if (!line) continue
          const data = JSON.parse(line.slice(6))
          if (data.delta) {
            if (state.target) {
              if (state.typing.isConnected) state.typing.remove()
              state.target.textContent += data.delta
              this.scrollToEnd(false)
            } else {
              state.pending += data.delta // ไพ่ยังพลิกไม่จบ — พักไว้ก่อน
            }
          } else if (data.done) {
            if (state.bubble) {
              this.finishStream(data, state.stream, state.bubble, state.target)
            } else {
              state.done = data
            }
          }
        }
      }
      if (state.typing.isConnected && state.target) state.typing.remove()
    } catch (error) {
      if (state.target) {
        state.typing.remove()
        this.showStreamFailure(state.stream, state.target)
      } else {
        state.failed = true // bubble ยังไม่เกิด — ให้ attachStream จัดการตอนพร้อม
      }
    }
  }

  finishStream(data, stream, bubble, target) {
    if (data.failed) {
      this.showStreamFailure(stream, target)
    } else if (data.invite) {
      const invite = document.createElement("p")
      invite.className = "oracle-answer-text oracle-answer-followup-invite"
      invite.textContent = data.invite
      bubble.appendChild(invite)
    }
    if (data.chips) {
      this.chipsValue = data.chips
      this.renderChips()
    }
    this.updateCredits(data.credits) // AI พังแล้ว server คืนเครดิต — เลขต้องเด้งกลับเอง
    this.scrollToEnd()
  }

  // ---- เครดิต ----

  updateCredits(value) {
    if (value === undefined || value === null || !this.hasCreditsTarget) return

    this.creditsCountTarget.textContent = value
    this.creditsTarget.classList.toggle("is-low", value <= Number(this.creditsTarget.dataset.lowAt || 3))
  }

  openTopup(message) {
    if (!this.hasTopupTarget) return

    this.closeZoom() // ไพ่ขยายอยู่ z สูงกว่าโมดัลนี้ ต้องเก็บก่อน ไม่งั้นโมดัลเติมเครดิตโดนบัง

    if (message) this.topupTextTarget.textContent = message
    this.topupTarget.hidden = false
  }

  closeTopup() {
    if (this.hasTopupTarget) this.topupTarget.hidden = true
  }

  // ---- ขยายไพ่ใบเดียว (Lek สั่ง 3 ส.ค. 69 — ไพ่ในแชทเล็กลงแล้ว อยากดูชัดให้แตะ) ----
  // รับสองที่: ใบในกล่องคำตอบ (.oracle-card) กับใบในช่องพัดที่พลิกหงายแล้ว
  // ใบที่ยังคว่ำห้ามขยาย — ยังต้องแตะเพื่อคืนใบกลับพัดอยู่
  zoom(event) {
    if (!this.hasZoomTarget) return

    const card = event.target.closest(".oracle-card, .flip-card.is-flipped")
    if (!card) return

    const art = card.querySelector("img[src]:not([hidden])")
    if (!art) return // ใบที่ยังไม่มีรูป (ทางถอย) — ขยายเลขดาวไปก็ไม่ได้อะไร

    this.zoomArtTarget.src = art.src
    this.zoomArtTarget.alt = art.alt || ""
    this.zoomNameTarget.textContent =
      card.querySelector(".oracle-card-name, .flip-card-name")?.textContent || art.alt || ""
    this.zoomTarget.hidden = false
  }

  closeZoom() {
    if (this.hasZoomTarget) this.zoomTarget.hidden = true
  }

  // stream พัง — บอกตรง ๆ + ข้อเปิดวงมีปุ่มอ่านซ้ำ (คำถามต่อที่พังไม่นับโควตา ถามใหม่ได้เลย)
  showStreamFailure(stream, target) {
    target.textContent = this.textsValue.read_failed
    if (stream.kind === "first") {
      const retry = document.createElement("button")
      retry.type = "button"
      retry.className = "oracle-retry"
      retry.dataset.action = "oracle-chat#reread"
      retry.dataset.drawId = stream.id
      retry.textContent = this.textsValue.reread
      target.after(retry)
    } else {
      target.textContent += this.textsValue.ask_again
    }
    this.renderChips()
  }

  // arts = url รูปรายใบที่ server เลือกสำรับมาแล้ว (สองสำรับ ดาวเดียวกันคนละภาพ) —
  // ต้องใช้ตัวนี้ ไม่ใช่ artsValue ไม่งั้นไพ่ที่พลิกกับไพ่ใน bubble คำตอบเป็นคนละภาพ
  async reveal(cards, arts) {
    const artOf = (i) => (arts && arts[i]) || this.artsValue[cards[i]]
    await this.preloadArt(cards, artOf)
    this.fanPicked.forEach((entry, i) => {
      const card = entry.slot.querySelector(".flip-card")
      const code = cards[i]
      card.querySelector("[data-card-glyph]").textContent = code
      card.querySelector("[data-card-name]").textContent = this.namesValue[code] || ""
      const color = this.colorsValue[code]
      if (color) card.classList.add(color)
      const art = artOf(i)
      if (art) {
        const image = card.querySelector("[data-card-art]")
        image.src = art
        image.alt = this.namesValue[code] || ""
        image.hidden = false
        card.querySelector("[data-card-front]").classList.add("has-art")
      }
      setTimeout(() => card.classList.add("is-flipped"), 300 + i * 250)
    })
    // พักสั้น ๆ ให้เห็นไพ่หงายครบ — คำตอบมักไหลมารออยู่แล้ว (stream เปิดตั้งแต่ตอนพลิก)
    await new Promise((resolve) => setTimeout(resolve, 300 + cards.length * 250 + 400))
  }

  preloadArt(cards, artOf) {
    const urls = cards.map((_, i) => artOf(i)).filter(Boolean)
    if (urls.length === 0) return Promise.resolve()
    const loaded = Promise.all(urls.map((url) => new Promise((resolve) => {
      const image = new Image()
      image.onload = resolve
      image.onerror = resolve
      image.src = url
    })))
    return Promise.race([loaded, new Promise((resolve) => setTimeout(resolve, 2500))])
  }

  // ---- อ่านข้อเปิดวงซ้ำ (AI พังรอบก่อน — ไพ่ชุดเดิม ไม่เปลืองโควตา) ----

  async reread(event) {
    if (this.busy) return
    this.busy = true
    const button = event.currentTarget
    const bubble = button.closest(".oracle-bubble")
    button.disabled = true
    button.textContent = this.textsValue.reading
    try {
      const data = await this.post(this.rereadUrlValue, { draw_id: button.dataset.drawId })
      const html = (data.bubbles || [])[0]
      if (html && bubble) {
        const fresh = document.createElement("div")
        fresh.className = "oracle-bubble is-oracle"
        fresh.innerHTML = html
        bubble.replaceWith(fresh)
      }
      this.chipsValue = data.chips || this.chipsValue
      this.renderChips()
      this.scrollToEnd()
    } catch (error) {
      button.disabled = false
      button.textContent = this.textsValue.reread_short
    } finally {
      this.busy = false
    }
  }

  // ---- เริ่มใหม่ (ช่วงเทส — ล้างวงของวันนี้แล้วโหลดหน้าใหม่) ----

  async reset(event) {
    if (!window.confirm(this.textsValue.reset_confirm)) return
    try {
      await this.post(event.params.resetUrl, {})
      window.location.reload()
    } catch (error) { /* กดใหม่ได้ */ }
  }

  // ---- rating ----

  async rate(event) {
    const rating = event.currentTarget.dataset.rating
    try {
      await this.post(this.rateUrlValue, { rating })
      if (this.hasRatingTarget) this.ratingTarget.remove()
      this.appendBubble("is-oracle", this.textsValue.thanks)
      this.scrollToEnd()
    } catch (error) { /* กดใหม่ได้ ปุ่มยังอยู่ */ }
  }

  // ---- ชิปชุดเดียว: คำถามต่อที่ AI คิดให้ + คำถามชวนถาม (ไม่มีเรื่องหมวดแล้ว) ----
  // ยกเว้นความรักที่ยุบเป็นชิปเดียวแล้วค่อยเลือกสถานะ (Lek เคาะ 3 ส.ค. 69) — ดู openLoveMenu

  renderChips() {
    if (!this.hasChipsTarget) return
    this.chipsTarget.innerHTML = ""

    const love = this.chipsValue.love
    if (love && love.options && love.options.length) this.addChip(love.label, () => this.openLoveMenu(love))
    ;(this.chipsValue.questions || []).forEach((question) => this.addChip(question))
  }

  addChip(label, handler, category) {
    const button = document.createElement("button")
    button.type = "button"
    button.className = handler ? "oracle-chip oracle-chip-switch" : "oracle-chip"
    button.textContent = label
    button.addEventListener("click", handler || (() => this.ask(label, category)))
    this.chipsTarget.appendChild(button)
  }

  // ---- เมนูความรักสองชั้น ----
  // ทั้งเมนูเป็นการสลับชิปบนจอล้วน ๆ ไม่ยิง server สักครั้ง (ไม่มีค่า API ระหว่างเดินเมนู)
  // คำถามชั้นในส่งหมวดไปด้วย ฝั่ง server จะข้าม AI router เพราะรู้หมวดแน่นอนแล้ว
  // ถ้อยคำทุกชิ้น (ป้ายสถานะ/คำถามของแม่หมอ/ปุ่มย้อนกลับ) มาจาก payload ฝั่ง server

  openLoveMenu(love) {
    // คำถามของแม่หมอวางครั้งเดียว เดินเข้าออกชั้นในไม่ต้องถามซ้ำให้รก
    if (!this.loveBubble || !this.loveBubble.isConnected) {
      this.loveBubble = this.appendBubble("is-oracle", love.prompt)
    }
    // ทางถอยอยู่หน้าสุดทั้งสองชั้น — แถวชิปเลื่อนแนวนอน ถ้าวางท้ายแถวคำถามยาว ๆ จะดันจนไม่เห็น
    this.chipsTarget.innerHTML = ""
    this.addChip(love.back, () => this.closeLoveMenu())
    love.options.forEach((option) => this.addChip(option.label, () => this.openLoveQuestions(love, option)))
    this.scrollToEnd()
  }

  openLoveQuestions(love, option) {
    this.chipsTarget.innerHTML = ""
    this.addChip(love.back_status, () => this.openLoveMenu(love))
    option.questions.forEach((question) => this.addChip(question, null, option.category))
  }

  // ถามความรักมาเองโดยไม่บอกสถานะ — แม่หมอถามกลับ แล้วรอกดสถานะ (ยังไม่หักเครดิต)
  // กดแล้วส่ง "คำถามเดิมที่พิมพ์มา" ซ้ำพร้อมหมวด ไม่ใช่คำถามสำเร็จรูปของหมวดนั้น
  askLoveStatus(data) {
    this.loveBubble = this.appendBubble("is-oracle", data.prompt)
    this.chipsTarget.innerHTML = ""
    data.options.forEach((option) => this.addChip(option.label, () => this.ask(data.question, option.category)))
    this.scrollToEnd()
  }

  // ถอยออกจากเมนู = เก็บคำถามที่แม่หมอถามสถานะออกจากสายแชทด้วย ไม่ทิ้งค้างไว้ให้งง
  closeLoveMenu() {
    this.loveBubble?.remove()
    this.loveBubble = null
    this.renderChips()
  }

  // ---- ชิ้นส่วนจอ ----

  appendBubble(kind, text, html) {
    const bubble = document.createElement("div")
    bubble.className = `oracle-bubble ${kind}`
    if (html) { bubble.innerHTML = html } else { bubble.textContent = text }
    // กล่องที่มีแถวไพ่จัดย่อหน้าด้วยแท็กเอง ไม่ต้องพึ่ง pre-line (ไม่งั้นได้บรรทัดเปล่าคั่นไพ่กับข้อความ)
    if (bubble.querySelector(".oracle-cards-row")) bubble.classList.add("has-cards")
    this.threadTarget.appendChild(bubble)
    this.scrollToEnd()
    return bubble
  }

  // ป้ายราคาก่อนกรีดไพ่ — ไม่มีกล่องเด้งยืนยัน (Lek เคาะ 3 ส.ค. 69) การกรีดไพ่คือการยืนยันในตัว
  // ถ้อยคำจาก texts ที่มีตัวแปรแบบ %{name} ของ Rails i18n
  t(key, vars = {}) {
    return Object.entries(vars).reduce((text, [k, v]) => text.replace(`%{${k}}`, v), this.textsValue[key] || "")
  }

  appendCost(hint) {
    if (!hint) return

    const line = document.createElement("div")
    line.className = "oracle-cost"
    line.textContent = hint
    this.threadTarget.appendChild(line)
    this.scrollToEnd()
  }

  appendTyping() {
    const bubble = document.createElement("div")
    bubble.className = "oracle-bubble is-oracle oracle-typing"
    bubble.innerHTML = "<span></span><span></span><span></span>"
    this.threadTarget.appendChild(bubble)
    this.scrollToEnd()
    return bubble
  }

  scrollToEnd(smooth = true) {
    requestAnimationFrame(() => {
      window.scrollTo({ top: document.body.scrollHeight, behavior: smooth ? "smooth" : "auto" })
    })
  }

  async post(url, body) {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
      },
      body: JSON.stringify(body)
    })
    if (!response.ok) {
      const error = new Error(`post failed: ${response.status}`)
      error.status = response.status // 402 = เครดิตหมด ฝั่งเรียกเอาไปเด้งโมดัลเติมเครดิต
      // ฝั่ง server ส่งเหตุผลมาใน error (เช่น โควตาเรื่องนี้หมด) — โชว์เป็นเสียงแม่หมอ
      try { error.userMessage = (await response.json()).error } catch { /* ไม่มี body ก็ข้าม */ }
      throw error
    }
    return response.json()
  }
}
